import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id", "aria-describedby", "aria-invalid", "list", "min", "name", "placeholder", "type"]
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "form__indicator"
}
const _hoisted_4 = {
  key: 1,
  class: "form__tooltip"
}
const _hoisted_5 = ["id"]

import {required, Rule} from '@/validation/rules'
import {Status, validate} from '@/validation'
import {ref, watch} from "vue";

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'FormInput',
  props: {
    name: {},
    label: {},
    modelValue: {},
    placeholder: {},
    type: {},
    rules: {},
    tooltip: {},
    list: {}
  },
  emits: ["update:modelValue", "validated"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

// eslint-disable-next-line
__expose({
  //to call validation in parent.
  validateInput
})

const inputValue = ref<string | number | undefined>(props.modelValue === '' ? undefined : props.modelValue);
watch(props, () => inputValue.value = props.modelValue === '' ? undefined : props.modelValue)

// eslint-disable-next-line
const emit = __emit;

const status = ref<Status>({valid: true});
const isRequired = !(props.rules != undefined && props.rules.length == 0);

function handleInput() {
  reformatInput()
  validateInput();
  inputValue.value = inputValue.value === '' ? undefined : inputValue.value
  emit("update:modelValue", inputValue.value);
}

function handleBlur() {
  validateInput();
}

function validateInput() {
  let validationRules = props.rules ? props.rules : [required]
  status.value = validate(inputValue.value as string, validationRules)
  emit("validated", props.name, status.value);
}

function reformatInput() {
  if (props.type === "tel")
    reformatPhoneNumber()
  else if (props.type === "zip")
    reformatZipCode()
}

function reformatPhoneNumber() {
  let trimmedPhoneNumber = (inputValue.value as string).replace(/\D/g, '');
  if (trimmedPhoneNumber.length === 11) {
    let x = trimmedPhoneNumber.match(/(\d?)(\d{0,3})(\d{0,3})(\d{0,4})/);
    if (!x)
      return;
    inputValue.value = !x[2] ? x[1] : `${x[1]}-${x[2]}` + (x[3] ? `-${x[3]}` + (x[4] ? `-${x[4]}` : '') : '');
    return;
  }
  let x = trimmedPhoneNumber.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  if (!x)
    return;
  inputValue.value = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
}

function reformatZipCode() {
  inputValue.value = (inputValue.value as string).replace(' ', '').toUpperCase()
  if (inputValue.value.length <= 9)
    return;
  inputValue.value = inputValue.value.substring(0,9);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{'error':!status.value.valid}, "form__field"])
  }, [
    _renderSlot(_ctx.$slots, "before-input"),
    _withDirectives(_createElementVNode("input", {
      id: _ctx.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
      "aria-describedby": `error__${_ctx.name}`,
      "aria-invalid": !status.value.valid,
      list: _ctx.list,
      min: _ctx.type == 'number' ? '0' : '',
      name: _ctx.name,
      placeholder: _ctx.placeholder,
      type: _ctx.type,
      onBlur: handleBlur,
      onInput: handleInput
    }, null, 40, _hoisted_1), [
      [_vModelDynamic, inputValue.value]
    ]),
    _createElementVNode("label", { for: _ctx.name }, [
      _createTextVNode(_toDisplayString(_ctx.label ? _ctx.label : _ctx.name) + " ", 1),
      isRequired
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
        : _createCommentVNode("", true),
      (_ctx.tooltip)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.tooltip), 1))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2),
    (!status.value.valid)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          id: `error__${_ctx.name}`,
          class: "form__error-message"
        }, _toDisplayString(status.value.message), 9, _hoisted_5))
      : _createCommentVNode("", true)
  ], 2))
}
}

})